const Config = require('~/config/default.env').default;

// store_location_id cookie can be missing, "undefined" or a legacy numeric id, only a 24-hex id is a store
const isValidStoreId = (storeId) => typeof storeId === 'string' && /^[a-f0-9]{24}$/i.test(storeId);
const storeIdHeader = (storeId) => (isValidStoreId(storeId) ? { store_id: storeId } : {});

const PRICE_CHECKER_BANNER_REQUESTS = {
  ID: {
    source: 'price_checker',
    activeFilters: { is_active_in_offline_store: true, is_active: true },
  },
  SG: {
    source: 'price_checker_sg',
    activeFilters: { is_active_in_offline_store_sg: true, is_active_in_sociolla_sg: true },
  },
};

const fetchPriceCheckerBanner = async (commit, location, request) => {
  if (!location) {
    return null;
  }

  const loc = await Cookies.get('store_location_id');
  if (!isValidStoreId(loc)) {
    return null;
  }

  return axios
    .get(`${Config.MS_CATALOG_API_URL}/banners/all`, {
      headers: {
        ...storeIdHeader(loc),
        'SOC-PLATFORM': request.source,
        'soc-source': request.source,
      },
      params: {
        filter: {
          locations: [location],
          ...request.activeFilters,
          is_deleted: false,
          start_date: { $lte: new Date() },
          end_date: { $gte: new Date() },
        },
        limit: 20,
        sort: '-created_at',
      },
    })
    .then((response) => {
      if (response && response.data && response.data.data && location in response.data.data) {
        let selected_banner = null;
        let banners = response.data.data[location];
        banners = banners.sort((a, b) => a.position - b.position);

        for (let i = 0; i < banners.length; i++) {
          const banner = banners[i];
          const findStore = banner.stores.find((s) => s.id === loc);

          if (!findStore) {
            continue;
          }

          selected_banner = banner;
          break;
        }

        if (selected_banner) {
          console.log('set banner');
          commit('SET_BANNER', {
            type: location === 'store_admin_price_checker_idle' ? 'idle' : 'pdp',
            value: selected_banner.images[0].url,
          });
        }
      }
    });
};

export default {
  state: {
    banners: {
      idle: null,
      pdp: [],
    },
    product_detail: null,
    search_product: [],
    scanned_combination: {},
    bundle_product: null,
    loading_product_detail: true,
    idle_check: 'initiate',
  },
  mutations: {
    SET_SCANNED_COMBINATION(state, value) {
      state.scanned_combination = value;
    },
    SET_IDLE_CHECK(state, value) {
      state.idle_check = value;
    },
    SET_BANNER(state, { type, value }) {
      state.banners[type] = value;
    },
    SET_PRODUCT_DETAIL(state, value) {
      state.product_detail = value;
    },
    SET_SEARCH_PRODUCT(state, value) {
      state.search_product = [];
      state.search_product = value;
    },
    SET_LOADING_PRODUCT_DETAIL(state, value) {
      state.loading_product_detail = value;
    },
    SET_BUNDLE_PRODUCT(state, value) {
      state.bundle_product = value;
    },
    CLEAR_SEARCH_PRODUCTS(state) {
      state.search_product = [];
    },
  },
  actions: {
    async setIdleCheck({ commit }, value) {
      commit('SET_IDLE_CHECK', value);
    },
    async setScannedCombination({ commit }, product) {
      commit('SET_SCANNED_COMBINATION', product);
    },
    async getProductDetail({ commit }, { barcode }) {
      if (!barcode || barcode.length === 0) {
        return null;
      }
      commit('SET_PRODUCT_DETAIL', null);
      commit('SET_BUNDLE_PRODUCT', null);
      commit('SET_LOADING_PRODUCT_DETAIL', true);
      const loc = await Cookies.get('store_location_id');
      return axios({
        url: `${Config.MS_CATALOG_API_URL}/v3/products`,
        method: 'get',
        headers: {
          ...storeIdHeader(loc),
          'SOC-PLATFORM': 'sociolla_store',
          'soc-source': 'sociolla_store',
        },
        params: {
          filter: {
            'combinations.ean_no': barcode,
            is_active_in_offline_store: true,
            price_checker: true,
          },
        },
      })
        .then((res) => {
          if (res && res.data && res.data.data && res.data.data.length > 0) {
            commit('SET_PRODUCT_DETAIL', res.data.data[0]);
            const productId = res.data.data[0].id;
            axios({
              url: `${Config.MS_CATALOG_API_URL}/v3/products/${productId}/bundles`,
              method: 'get',
              headers: {
                ...storeIdHeader(loc),
                'SOC-PLATFORM': 'offline_store',
                'soc-source': 'offline_store',
              },
              params: {
                skip: 0,
                limit: 3,
              },
            }).then((res) => {
              if (res.data.data && res.data.data.length > 0) {
                commit('SET_BUNDLE_PRODUCT', res.data.data);
              }
            });
          } else {
            commit('SET_PRODUCT_DETAIL', null);
            commit('SET_BUNDLE_PRODUCT', null);
          }
        })
        .catch((err) => {
          console.log(err);
          commit('SET_PRODUCT_DETAIL', null);
          commit('SET_BUNDLE_PRODUCT', null);
        })
        .finally(() => {
          commit('SET_LOADING_PRODUCT_DETAIL', false);
        });
    },
    async getProductDetailVn({ commit }, { barcode }) {
      if (!barcode || barcode.length === 0) {
        return null;
      }
      commit('SET_PRODUCT_DETAIL', null);
      commit('SET_BUNDLE_PRODUCT', null);
      commit('SET_LOADING_PRODUCT_DETAIL', true);
      const loc = await Cookies.get('store_location_id');
      return axios({
        url: `${Config.MS_CATALOG_API_URL}/v3/products`,
        method: 'get',
        headers: {
          ...storeIdHeader(loc),
          'SOC-PLATFORM': 'sociolla_store_vn',
          'soc-source': 'sociolla_store_vn',
        },
        params: {
          filter: {
            'combinations.ean_no': barcode,
            //is_active_in_offline_store: true,
            price_checker: true,
          },
        },
      })
        .then((res) => {
          if (res && res.data && res.data.data && res.data.data.length > 0) {
            commit('SET_PRODUCT_DETAIL', res.data.data[0]);
            const productId = res.data.data[0].id;
            axios({
              url: `${Config.MS_CATALOG_API_URL}/v3/products/${productId}/bundles`,
              method: 'get',
              headers: {
                ...storeIdHeader(loc),
                'SOC-PLATFORM': 'offline_store',
                'soc-source': 'offline_store',
              },
              params: {
                skip: 0,
                limit: 3,
              },
            }).then((res) => {
              if (res.data.data && res.data.data.length > 0) {
                commit('SET_BUNDLE_PRODUCT', res.data.data);
              }
            });
          } else {
            commit('SET_PRODUCT_DETAIL', null);
            commit('SET_BUNDLE_PRODUCT', null);
          }
        })
        .catch((err) => {
          console.log(err);
          commit('SET_PRODUCT_DETAIL', null);
          commit('SET_BUNDLE_PRODUCT', null);
        })
        .finally(() => {
          commit('SET_LOADING_PRODUCT_DETAIL', false);
        });
    },
    async getProductDetailSg({ commit }, { barcode }) {
      if (!barcode || barcode.length === 0) {
        return null;
      }
      barcode = barcode.trim();
      commit('SET_PRODUCT_DETAIL', null);
      commit('SET_BUNDLE_PRODUCT', null);
      commit('SET_LOADING_PRODUCT_DETAIL', true);
      const loc = await Cookies.get('store_location_id');
      const headers = {
        ...storeIdHeader(loc),
        'SOC-PLATFORM': 'sociolla_store_sg',
        'soc-source': 'sociolla_store_sg',
      };

      try {
        const res = await axios({
          url: `${Config.MS_CATALOG_API_URL}/v3/products`,
          method: 'get',
          headers,
          params: {
            filter: {
              $or: [{ 'combinations.ean_no': barcode }],
              is_active_in_offline_store: true,
              price_checker: true,
            },
          },
        });

        const product = res?.data?.data?.[0];
        if (!product) {
          return;
        }
        commit('SET_PRODUCT_DETAIL', product);

        const bundleRes = await axios({
          url: `${Config.MS_CATALOG_API_URL}/v3/products/${product.id}/bundles`,
          method: 'get',
          headers,
          params: {
            skip: 0,
            limit: 3,
          },
        });
        if (bundleRes.data.data && bundleRes.data.data.length > 0) {
          commit('SET_BUNDLE_PRODUCT', bundleRes.data.data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        commit('SET_LOADING_PRODUCT_DETAIL', false);
      }
    },
    //For text search
    async getProductsDetailBySearch({ commit }, { search }) {
      commit('SET_PRODUCT_DETAIL', null);
      commit('SET_BUNDLE_PRODUCT', null);
      commit('SET_LOADING_PRODUCT_DETAIL', true);
      const loc = await Cookies.get('store_location_id');
      await axios({
        url: `${Config.MS_CATALOG_API_URL}/v3/products`,
        method: 'get',
        headers: {
          ...storeIdHeader(loc),
          'SOC-PLATFORM': 'offline_store_vn',
          'soc-source': 'offline_store_vn',
        },
        params: {
          filter: {
            $or: [
              { 'i18n.vi.name': { $regex: search, $options: 'i' } },
              { 'i18n.vi.brand.name': { $regex: search, $options: 'i' } },
              //{ 'combinations.ean_no': barcode },
            ],
            is_active_in_sociolla_vn: true,
            price_checker: true,
          },
        },
      })
        .then((res) => {
          if (res && res.data && res.data.data && res.data.data.length > 0) {
            commit('SET_SEARCH_PRODUCT', res.data.data);
          } else {
            commit('CLEAR_SEARCH_PRODUCTS');
          }
        })
        .catch((err) => {
          console.log(err);
          commit('SET_PRODUCT_DETAIL', null);
          commit('SET_BUNDLE_PRODUCT', null);
        })
        .finally(() => {
          commit('SET_LOADING_PRODUCT_DETAIL', false);
        });
    },
    getDandelionStoreBanner({ commit }, location) {
      return fetchPriceCheckerBanner(commit, location, PRICE_CHECKER_BANNER_REQUESTS.ID);
    },
    getDandelionStoreBannerSg({ commit }, location) {
      return fetchPriceCheckerBanner(commit, location, PRICE_CHECKER_BANNER_REQUESTS.SG);
    },

    async getDandelionStoreBannerLilla({ commit }, location) {
      if (!location) {
        return null;
      }

      const loc = await Cookies.get('store_location_id');

      return axios
        .get(`${Config.MS_CATALOG_API_URL}/banners/all`, {
          headers: {
            store_id: loc,
            'SOC-PLATFORM': 'price_checker_lilla',
            'soc-source': 'price_checker_lilla',
          },
          params: {
            filter: {
              locations: [location],
              is_active_in_offline_store_lilla: true,
              is_active: true,
              is_deleted: false,
              start_date: { $lte: new Date() },
              end_date: { $gte: new Date() },
            },
            sort: '-created_at',
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data && location in response.data.data) {
            let selected_banner = null;
            let banners = response.data.data[location];
            banners = banners.sort((a, b) => a.position - b.position);

            for (let i = 0; i < banners.length; i++) {
              const banner = banners[i];
              const findStore = (banner.lilla_stores || []).find((s) => s.id === loc);

              if (!findStore) {
                continue;
              }

              selected_banner = banner;
              break;
            }

            if (selected_banner) {
              commit('SET_BANNER', {
                type: location === 'store_admin_price_checker_idle' ? 'idle' : 'pdp',
                value: selected_banner.images[0].url,
              });
            }
          }
        });
    },

    async getDandelionStoreBannerVn({ commit }, location) {
      if (!location) {
        return null;
      }

      const loc = await Cookies.get('store_location_id');
      if (!isValidStoreId(loc)) {
        return null;
      }
      return axios({
        url: `${Config.MS_CATALOG_API_URL}/banners/all`,
        method: 'get',
        headers: {
          store_id: loc,
          'SOC-PLATFORM': 'price_checker_vn',
          'soc-source': 'price_checker_vn',
        },
        params: {
          filter: {
            locations: [location],
            is_active_in_sociolla_vn: true,
            is_deleted: false,
            start_date: { $lte: new Date() },
            end_date: { $gte: new Date() },
          },
          sort: '-created_at',
        },
      }).then((response) => {
        if (response && response.data && response.data.data && location in response.data.data) {
          let banners = response.data.data[location];
          banners = banners.sort((a, b) => a.position - b.position);

          const pdpBanners = []; // Array to store all PDP banners
          const idleBanners = [];

          for (let i = 0; i < banners.length; i++) {
            const banner = banners[i];
            const findStore = banner.stores.find((s) => s.id === loc);

            if (!findStore) {
              continue;
            }

            if (location === 'store_admin_price_checker_pdp') {
              pdpBanners.push(banner.images[0].url);
            } else if (location === 'store_admin_price_checker_idle') {
              // commit('SET_BANNER', {
              //   type: 'idle',
              //   value: banner.images[0].url,
              // });
              idleBanners.push(banner.images[0].url);
            }
          }

          if (pdpBanners.length > 0) {
            commit('SET_BANNER', {
              type: 'pdp',
              value: [...pdpBanners],
            });
          }

          if (idleBanners.length > 0) {
            commit('SET_BANNER', {
              type: 'idle',
              value: [...idleBanners],
            });
          }
        }
      });
    },
  },
};
